module.exports = __webpack_public_path__ + "img/popup-header-winning.59cfc4fc.png";